import { render, staticRenderFns } from "./SchoolList.vue?vue&type=template&id=f5ee1d46&scoped=true"
import script from "./SchoolList.vue?vue&type=script&lang=js"
export * from "./SchoolList.vue?vue&type=script&lang=js"
import style0 from "./SchoolList.vue?vue&type=style&index=0&id=f5ee1d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ee1d46",
  null
  
)

export default component.exports